import { httpClient } from "../../httpClient";
import { Environment } from "../../../store";

type Payload = {
    name: string;
    isActive: boolean;
};

type Data = any;

export async function postEnvironment(payload: Payload): Promise<any> {
  try {
    const { data } = await httpClient.post<Data>(`/api/v1/environments`, payload);

    return data;
  } catch (error) {
      console.log(error);
    throw error;
  }
}

export async function editEnvironment(id: Environment["id"], payload: Payload): Promise<boolean> {
    try {
        const response = await httpClient.put(`/api/v1/environments/${id}`, payload);

        return response.status === 200;
    } catch (error) {
        throw error;
    }
}

export const environment = {
    postEnvironment,
    editEnvironment,
};